/**
 * Утита для работы с URL, парсинг на части, получение объекта из параметров
 */
export default class Url {
  constructor(url = '') {
    this.link = document.createElement('a');
    this.hash = null;
    this.host = null;
    this.hostname = null;
    this.href = null;
    this.origin = null;
    this.pathname = null;
    this.port = null;
    this.protocol = null;
    this.search = null;
    this.params = null;
    this.paramsObj = {};

    this.changeUrl(url);
  }

  /**
   * Метод парсит URL на стандартные составляюшие, и отдает их
   * @returns {{hostname: string, protocol: string, search: string, port: string, origin: string,
   * host: string, href: string, hash: string, pathname: string}}
   */
  parseUrl() {
    this.hash = this.link.hash;
    this.host = this.link.host;
    this.hostname = this.link.hostname;
    this.href = this.link.href;
    this.origin = this.link.origin;
    this.pathname = this.link.pathname;
    this.port = this.link.port;
    this.protocol = this.link.protocol;
    this.search = this.link.search;
    this.params = this.search.substring(1);
  }

  /**
   * Метод парсит параметры из URl.
   */
  parseParam() {
    const arg = '?';
    const sptr = arg.charAt(0);
    const split = this.params.split('&');
    let field = [];
    const params = {};
    let tmp = [];
    const arg2 = arg.substring(1);

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < split.length; i++) {
      field = split[i].match(/(.*?)=(.*)/);

      if (!field) {
        field = [split[i], split[i], ''];
      }

      if (field[1].replace(/\s/g, '') !== '') {
        field[2] = decodeURIComponent((field[2] || '').replace(/\+/g, ' '));

        // If we have a match just return it right away.
        if (arg2 === field[1]) {
          // eslint-disable-next-line prefer-destructuring
          this.paramsObj = field[2];
          return;
        }

        // Check for array pattern.
        tmp = field[1].match(/(.*)\[([0-9]+)\]/);

        if (tmp) {
          params[tmp[1]] = params[tmp[1]] || [];

          // eslint-disable-next-line prefer-destructuring
          params[tmp[1]][tmp[2]] = field[2];
        } else {
          // eslint-disable-next-line prefer-destructuring
          params[field[1]] = field[2];
        }
      }
    }

    if (sptr === arg) {
      this.paramsObj = params;
      return;
    }

    this.paramsObj = params[arg2];
  }

  /**
   * Описание
   * @param url
   */
  changeUrl(url) {
    this.link.href = url;
    this.parseUrl();
    this.parseParam();
  }
}
